import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  inject
} from "@angular/core";
import { Ticket_BasicProjection } from "@app/models/rest/ticket";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { ResourceStore } from "@app/services/store/resource-store";
import { Subject } from "rxjs";

@Component({
  selector: "app-ticket-expand",
  templateUrl: "./ticket-expand.component.html",
  styleUrls: ["./ticket-expand.component.scss"],
  standalone: true,
  imports: [MatButton, MatIcon]
})
export class TicketExpandComponent implements OnInit, OnDestroy {
  private resourceStore = inject(ResourceStore);

  @Input() ticket!: Ticket_BasicProjection;
  @Input() draft: boolean = false;

  @Output() ticketClick = new EventEmitter<Ticket_BasicProjection>();

  public resourceImageUrl: string | null = null;
  private destroy$ = new Subject<void>();
  private loadedResourceId: number | null = null;

  ngOnInit(): void {
    this.loadResourceImage();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async loadResourceImage(): Promise<void> {
    const resourceId = this.ticket.resourceAvailability?.resource?.id;

    if (!resourceId || this.loadedResourceId === resourceId) {
      return;
    }

    try {
      const fullResource = await this.resourceStore.loadSingle(resourceId);
      this.resourceImageUrl = fullResource.imageUrl;
      this.loadedResourceId = resourceId;
    } catch (error) {
      console.error("Error loading resource image:", error);
      this.resourceImageUrl = null;
      this.loadedResourceId = null;
    }
  }

  onTicketClick(): void {
    this.ticketClick.emit(this.ticket);
  }
}
